import reduce from './utils/reduce'

const { assign } = Object

const pick = (model, keys) => {
  if (!keys.length || !model.selectors) return model

  const selectors = reduce(keys, (obj, key) => {
    const [name, replace] = key.split(':')

    return model.selectors.hasOwnProperty(name) ? assign(obj, {
      [replace || name]: model.selectors[name]
    }) : obj
  }, {})

  return assign(model, { selectors })
}

export default pick
